"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validate = validate;
exports.fixProperties = fixProperties;
const ramda_1 = require("ramda");
const utils_1 = require("./utils");
const VALIDATION_CYCLE_LIMIT = 100;
async function validate({ validator, value, options, shouldFixProperties = true }) {
    let i = 0;
    let prevValue = value;
    let result = await validator.validate(prevValue, options);
    if (shouldFixProperties) {
        result = fixProperties(result);
    }
    while (!(0, ramda_1.equals)(prevValue, result.value) && i < VALIDATION_CYCLE_LIMIT) {
        i++;
        prevValue = result.value;
        result = await validator.validate(prevValue, options);
        if (shouldFixProperties) {
            result = fixProperties(result);
        }
    }
    return result;
}
function fixProperties(result) {
    let { value } = result;
    // add optional properties
    for (const item of result.messages || []) {
        if ((0, utils_1.isLogItemWithPath)(item) &&
            item.path.length !== 0 &&
            item.details.presence === "optional" &&
            !(0, ramda_1.hasPath)(item.path, value)) {
            value = (0, ramda_1.assocPath)(item.path, undefined, value);
        }
    }
    // add required properties
    for (const item of result.errors || []) {
        if ((0, utils_1.isLogItemWithPath)(item) &&
            item.path.length !== 0 &&
            item.details.presence === "required" &&
            !(0, ramda_1.hasPath)(item.path, value)) {
            value = (0, ramda_1.assocPath)(item.path, undefined, value);
        }
    }
    // remove forbidden properties
    for (const item of result.errors || []) {
        if ((0, utils_1.isLogItemWithPath)(item) &&
            item.path.length !== 0 &&
            item.details.presence === "forbidden") {
            value = (0, ramda_1.dissocPath)(item.path, value);
        }
    }
    for (const item of result.messages || []) {
        if ((0, utils_1.isLogItemWithPath)(item) &&
            item.path.length !== 0 &&
            item.details.presence === "forbidden") {
            value = (0, ramda_1.dissocPath)(item.path, value);
        }
    }
    return { ...result, value };
}
